import React from "react";
import {
  Routes,
  Route,
  createBrowserRouter,
  RouterProvider,
  Outlet,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { publicRoutes, reportRoutes, authRoutes } from "./router.link";
import { useSelector } from "react-redux";
import Loader from "../feature-module/loader/loader";
import SessionExpiryHandler from "../core/Operations/SessionExpiryHandler";
import { base_path } from "environment";
import ReportSidebar from "InitialPage/Sidebar/ReportSidebar";
import ProtectedRoute from "./ProtectedRoute";
import Unauthorized from "MainPages/ErrorPages/unAuthorized";
const AllRoutes = () => {
  const isHeaderCollapsed = useSelector((state) => state.toggle_header);

  const HeaderLayout = () => (
    <div
      className={`main-wrapper ${isHeaderCollapsed ? "header-collapse" : ""}`}
    >
      <Header />
      <Sidebar />
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  const ReportHeaderLayout = () => (
    <div
      className={`main-wrapper ${isHeaderCollapsed ? "header-collapse" : ""}`}
    >
      <Header />
      <ReportSidebar />
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  const AuthPages = () => (
    <div className={isHeaderCollapsed ? "header-collapse" : ""}>
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  return (
    <BrowserRouter basename={base_path}>
      <SessionExpiryHandler />
      <Routes>
        {/* Authentication Routes */}
        {authRoutes.map((route) => (
          <Route key={route.id} path={route.path} element={<AuthPages />}>
            <Route path={route.path} element={route.element} />
          </Route>
        ))}

        {publicRoutes.map((route) => (
          <Route key={route.id} element={<HeaderLayout />}>
            <Route
              key={route.id}
              path={route.path}
              element={
                <ProtectedRoute
                  moduleCode={route.moduleCode}
                  accessCode={route.accessCode}
                  action={route.action || "haveView"}
                />
              }
            >
              <Route index element={route.element} />
            </Route>
          </Route>
        ))}
        {/* <Route path="/unauthorized" element={<Unauthorized />} /> */}

        {/* Public Routes */}
        {/* {publicRoutes.map((route) => (
            <Route key={route.id} path={route.path} element={<HeaderLayout />}>
              <Route path={route.path} element={route.element} />
            </Route>
          
        ))} */}

        {/* Public Routes */}
        {reportRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={
              <ProtectedRoute
                moduleCode={route.moduleCode}
                accessCode={route.accessCode}
                action={route.action || "haveView"}
              />
            }
          >
            <Route key={route.id} element={<ReportHeaderLayout />}>
              <Route index element={route.element} />
            </Route>
          </Route>
        ))}

        {/* {reportRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={<ReportHeaderLayout />}
          >
            <Route path={route.path} element={route.element} />
          </Route>
        ))} */}

        {/* Root and Not Found Redirections */}
        <Route path="/" element={<Navigate to="/" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );

  // const router = createBrowserRouter([
  //   {
  //     path: "/",
  //     element: (
  //       <>
  //         <SessionExpiryHandler />
  //         <AuthPages />
  //       </>
  //     ),
  //     children: authRoutes.map((route) => ({
  //       path: route.path,
  //       element: route.element,
  //     })),
  //   },
  //   {
  //     path: "/",
  //     element: (
  //       <>
  //         <SessionExpiryHandler />
  //         <HeaderLayout />
  //       </>
  //     ),
  //     children: publicRoutes.map((route) => ({
  //       path: route.path,
  //       element: route.element,
  //       loader: route.loader || undefined,
  //     })),
  //   },
  // ]);
  // return (
  //   <BrowserRouter basename={base_path}>
  //     <RouterProvider router={router} />
  //   </BrowserRouter>
  // );

  // return <RouterProvider router={router} />;
};

export default AllRoutes;
